import axios from 'axios';
import WorkItemType from '@/domain/work-item/work-item-type.entity';
import snackBarService from '@/shared/snackbar/snackbar.service';

export default class WorkItemFilterService {
  static getProjectCoreIdMapper(projectId?: string): Promise<string> {
    return axios
      .get(`/mapper/configuration/v2/byProject/${projectId}`)
      .then((response: any) => response.data)
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  static getProjectDirectivesMapper(projectMapperId?: string): Promise<string[]> {
    return axios
      .get(`/mapper/configuration/v2/${projectMapperId}`)
      .then((response: any) => response.data)
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  static getAllWorkItemTypes(): Promise<WorkItemType[]> {
    return axios.get('/workitems/types/actives')
      .then((response: any) => response.data.map((value: WorkItemType) => value))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  static getAllOriginSystems(): Promise<string[]> {
    return axios.get('/workitems/origin-system')
      .then((response: any) => response.data)
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  static getAllActiveStatus(): Promise<string[]> {
    return axios.get('/workitems/status')
      .then((response: any) => response.data.map((object: any) => object.description))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }
}
